import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';
import denApi from '@/lib/api/denApi';
import type { GroupProposal } from '@/types/group-proposal';

type DeleteGroupProposalArg = {
  groupId: string;
};

const fetcher = async (
  _key: string,
  { arg }: { arg: DeleteGroupProposalArg }
): Promise<GroupProposal> => {
  const { groupId } = arg;
  return await denApi.post<GroupProposal, void>(
    `admin/group/group-proposals/${encodeURIComponent(groupId)}/delete`,
    undefined
  );
};

export function useDeleteGroupProposal(
  swrOptions?: SWRMutationConfiguration<
    GroupProposal,
    Error,
    string,
    DeleteGroupProposalArg
  >
) {
  const { trigger, isMutating, error } = useSWRMutation<
    GroupProposal,
    Error,
    string,
    DeleteGroupProposalArg
  >('admin/group/group-proposals/delete', fetcher, swrOptions);

  return { deleteGroup: trigger, isLoading: isMutating, error };
}
